const state = {
  brands: [],
};

const mutations = {
  ADD_BRAND(state, brand) {
    state.brands.push(brand);
  },
};

const actions = {

  downloadBrand({ commit, rootState }, brand) {

    return new Promise(resolve => {
      rootState.Database.db
        .collection("brands")
        .doc(brand)
        .get()
        .then(doc => {
          const brandsTemp = doc.data();
          brandsTemp.id = doc.id;
          rootState.Database.storage.refFromURL(brandsTemp.logo).getDownloadURL().then(url => {
            brandsTemp.imageUrl = url;
            commit("ADD_BRAND", brandsTemp);
            resolve(true);
          }).catch(() => {
            resolve(false);
          });
        });
    });
  }
};

const getters = {
  getBrands(state) {
    return state.brands;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}; 



// WEBPACK FOOTER //
// ./src/store/modules/Brands.js